import React, { useMemo } from "react";
import MultiSelctCheckboxDropdown from "../../../../components/CheckboxMultiselect";
import { IconButton } from "@mui/material";
import downArrowImg from "../../../../styles/svg/downArrow.svg";
import { useSelector } from "react-redux";
import { useWorkflowById } from "../../../../reactQuery/workflows";
import { CustomButton } from "../../../../components/Button/Button";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";
import { getResponseData } from "../../../../reactQuery/response";
import { useListViewColumnFilter } from "./hooks/useListViewColumnFilter";

const StatusColumHeader = () => {
  const stepId = useSelector(
    (state) => state.listViewHeaderFilters.workFlowStepIds
  );
  const workflowId = useSelector(
    (state) => state.listViewHeaderFilters.workflowId
  );
  const { id: boardId } = useBoardIdByKey();
  const { data: workflows } = useWorkflowById(workflowId, boardId);
  const {
    anchorEl,
    handleClearFilter,
    handleClick,
    handleClose,
    handleSelectionChange,
    selectedItems,
  } = useListViewColumnFilter({
    filterKey: "statusFilter",
    resetKey: "workflow_Step",
    parseSelectedItems: Number,
  });
  const showStatus = useMemo(
    () =>
      getResponseData(workflows, [])
        .filter((workflow) => stepId.includes(workflow?.workflow_step_id))
        .sort((stepA, stepB) => stepA.step_sequence - stepB.step_sequence),
    [stepId, workflows]
  );

  return (
    <>
      <CustomButton className="remove-default-button-style reset-btn">
        <span>Status</span>
        <IconButton onClick={handleClick}>
          <img src={downArrowImg} alt="arrow" />
        </IconButton>
      </CustomButton>
      <MultiSelctCheckboxDropdown
        items={showStatus}
        selectedItems={selectedItems}
        onSelectionChange={handleSelectionChange}
        isButton={true}
        anchorEl={anchorEl}
        valueKey="workflow_step_id"
        displayKey="status"
        handleClose={handleClose}
        handleClearFilter={handleClearFilter}
      />
    </>
  );
};

export default StatusColumHeader;
